// extracted by mini-css-extract-plugin
module.exports = {"readMore":"styles_readMore__3jXpF","buttonArrow":"styles_buttonArrow__2K0Wd"};